import { render, staticRenderFns } from "./ImportPreloadCars.vue?vue&type=template&id=4227ed48&scoped=true&"
import script from "./ImportPreloadCars.vue?vue&type=script&lang=js&"
export * from "./ImportPreloadCars.vue?vue&type=script&lang=js&"
import style0 from "./ImportPreloadCars.vue?vue&type=style&index=0&id=4227ed48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4227ed48",
  null
  
)

export default component.exports